module.exports = __webpack_public_path__ + "c33fe68231c1f1839c72fb5ee404ac5d.png";